'use strict'

const $ = jQuery;
// const grade = window.grade

module.exports = {
  name: 'App',

  el: '.remind-tool',

  data: function () {
    return this.getInitalData()
  },

  methods: {
    getInitalData() {
      return {
        complete: false,
        frequency: 6,
        frequencyOptions: [3, 6, 12],
        sendSMS: false,
        sendEmail: false,
        user: {
          name: null,
          contact: {
            sms: null,
            email: null,
          },
        },
      }
    },

    subscribe: function () {
      // set base data
      const data = {
        name: this.user.name,
        mobile: this.user.contact.sms,
        email: this.user.contact.email,
        send_sms: +this.subscribedToSms,
        send_email: +this.subscribedToEmail,
        frequency: `+${this.frequency} Months`,
        subscribe_nonce: document.getElementById('subscribe_nonce').value
      }

      console.log(data)
      // post via AJAX
				$.ajax({
					method: "POST",
					url: "/wp-json/test-often/remind-me/subscribe", // grade.theme_url +  '/inc/actions/test-reminder-submit.php',
					data: data,
					dataType: "json",
					success: this.success,
					error: this.error,
				});
    },

    success: function () {
      this.complete = true
      // scroll to top of page
      $('html,body').animate({
        scrollTop: 0
      }, 600)
    },

    error: function () {
      window.alert('There was a problem setting up your reminder.\n\n' +
        'Please check you\'ve completed all the steps and try again.');
    },

    reset: function () {
      Object.assign(this.$data, this.getInitalData())
    },
  },

  computed: {
    step1Complete() {
      return !!this.sendSMS || !!this.sendEmail
    },
    step2Complete() {
			if (
				!!this.user.name &&
				this.sendEmail &&
				this.sendSMS
			) {
				return this.subscribedToEmail && this.subscribedToSms
			}

			if (
				!!this.user.name &&
				this.sendEmail &&
				!this.sendSMS
			) {
				return this.subscribedToEmail
			}

			if (
				!!this.user.name &&
				!this.sendEmail &&
				this.sendSMS
			) {
				return this.subscribedToSms
			}

      return false
    },
    subscribedToEmail() {
      return !!this.sendEmail && !!this.user.contact.email
    },
    subscribedToSms() {
      return !!this.sendSMS && !!this.user.contact.sms && this.isAustralianMobile
    },

    isAustralianMobile() {
    	if (this.user.contact.sms) {
    		const regex = /04\d{8}/g
    		const result = this.user.contact.sms.match(regex)
	    	return !!result
	    }
	    return false
    },

    preference: function () {
      const messages = []
      if (this.subscribedToSms) {
        messages.push('SMS to ' + this.user.contact.sms)
      }
      if (this.subscribedToEmail) {
        messages.push('e-mail to ' + this.user.contact.email)
      }
      return messages.join(' and an ')
    },
  }
}
